export const getAccessToken = () => {
  return localStorage.getItem('user-token')
    ? localStorage.getItem('user-token')
    : '';
};
